import Big from "big.js";
import {
  CURRENCIES,
  CURRENCIES_WITH_DIFFERENT_UNIT,
} from "../../constants/Currencies";

export const getConvertedValue = (
  conversionFactor = 0,
  value = 0,
  valuePrecisionLength,
  isMultiplicativeInverse = false,
) => {
  try {
    const bigConversionFactor = new Big(conversionFactor);
    const finalConversionFactor =
      // Using multiplicative inverse here to get converted value for 1 divide by conversion factor
      // Kept it here to abstract this logic from the component
      isMultiplicativeInverse && bigConversionFactor
        ? new Big(1).div(bigConversionFactor)
        : bigConversionFactor;
    const bigValue = new Big(value);
    const convertedValue = finalConversionFactor.times(bigValue);
    // Here we are checking if before decimal how many digits are present, if it is less than
    // max required textbox length, then we apply precision on decimal part based on
    // (max required textbox - on decimal part length)
    const valueParts = convertedValue.toString().split(".");
    return valueParts?.length && valueParts[0]?.length <= valuePrecisionLength
      ? convertedValue.toFixed(valuePrecisionLength - valueParts[0]?.length)
      : convertedValue.toFixed(0);
  } catch (error) {
    return value;
  }
};

export const getNormalisedFetchConversionRate = (
  params,
  quoteUnit = CURRENCIES.INR,
) => {
  return {
    ...params,
    from:
      params.from !== quoteUnit
        ? CURRENCIES_WITH_DIFFERENT_UNIT[params.from]
          ? `${CURRENCIES_WITH_DIFFERENT_UNIT[params.from]}${quoteUnit}`
          : `${params.from}${quoteUnit}`
        : params.from,
    to:
      params.to !== quoteUnit
        ? CURRENCIES_WITH_DIFFERENT_UNIT[params.to]
          ? `${CURRENCIES_WITH_DIFFERENT_UNIT[params.to]}${quoteUnit}`
          : `${params.to}${quoteUnit}`
        : params.to,
  };
};

export const getUniqueQuickBuyCurrencies = (currencies = {}) => {
  // Here Set is used to only return unique currency
  return [
    ...(new Set(
      Object.keys(currencies).map((item) =>
        item.replace(CURRENCIES.INR, "").replace(CURRENCIES.USDT, ""),
      ),
    ) || []),
  ];
};
